const DEFAULT_EFFECTS_ENABLED = false;

const tunaSettings = {
  Chorus: {
    feedback: 0.65, //[0,0.95]
    delay: 1, //[0,1],
    depth: 1, //[0,1]
    rate: 8, //[0,8]
    enabled: DEFAULT_EFFECTS_ENABLED
  },
  Delay: {
    feedback: 0.5,
    delayTime: 100,
    wetLevel: 1,
    dryLevel: 0,
    cutoff: 15000,
    enabled: DEFAULT_EFFECTS_ENABLED
  },
  Phaser: {
    rate: 5, //0.01 to 8 is a decent range, but higher values are possible
    depth: 1, //0 to 1
    feedback: 0.7, //0 to 1+
    stereoPhase: 150, //0 to 180
    baseModulationFrequency: 500, //500 to 1500
    enabled: DEFAULT_EFFECTS_ENABLED
  },
  Overdrive: {
    outputGain: 0.1, //0 to 1+
    drive: 0.7, //0 to 1
    curveAmount: 0.3, //0 to 1
    algorithmIndex: 2, //0 to 5, selects one of our drive algorithms
    enabled: DEFAULT_EFFECTS_ENABLED
  },
  Compressor: {
    threshold: -10, //-100 to 0
    makeupGain: 100, //0 and up
    attack: 100, //0 to 1000
    release: 300, //0 to 3000
    ratio: 5, //1 to 20
    knee: 10, //0 to 40
    automakeup: true, //true/false
    enabled: DEFAULT_EFFECTS_ENABLED
  },
  Filter: {
    frequency: 440, //20 to 22050
    Q: 16, //0.001 to 100
    gain: 10, //-40 to 40
    filterType: 0,
    enabled: DEFAULT_EFFECTS_ENABLED
  },
  Tremolo: {
    intensity: 0.8, //0 to 1
    rate: 8, //0.001 to 8
    stereoPhase: 100, //0 to 180
    enabled: DEFAULT_EFFECTS_ENABLED
  },
  Bitcrusher: {
    bits: 2, //1 to 16
    normfreq: 0.1, //0 to 1
    bufferSize: 256, //256 to 16384
    enabled: DEFAULT_EFFECTS_ENABLED
  },
  MoogFilter: {
    cutoff: 0.065, //0 to 1
    resonance: 3.5, //0 to 4
    bufferSize: 256, //256 to 16384
    enabled: DEFAULT_EFFECTS_ENABLED
  },
  PingPongDelay: {
    wetLevel: 0.5, //0 to 1
    feedback: 0.3, //0 to 1
    delayTimeLeft: 150, //1 to 1000 (milliseconds)
    delayTimeRight: 200, //1 to 1000 (milliseconds)
    enabled: DEFAULT_EFFECTS_ENABLED
  }
};

export default tunaSettings;



// WEBPACK FOOTER //
// ./src/tunaSettings.js